import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  @Input() title = '';
  @Input() msg = '';
  @Input() loading = false;
  constructor() { }
  ngOnInit(): void {
  }
}
